import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IrisIconComponent, IconSizes } from '@sondermind/iris/icon';

import { SegmentPreviewService } from '../../services/segment-preview.service';

@Component({
  selector: 'dev-tools-home',
  standalone: true,
  imports: [
    CommonModule,
    IrisIconComponent
  ],
  templateUrl: './dev-tools-home.component.html',
  styleUrl: './dev-tools-home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevToolsHomeComponent {
  readonly iconSizes = IconSizes;

  readonly toolSelected = output<string>();

  constructor(public segmentService: SegmentPreviewService) {}

  selectTool(toolId: string): void {
    this.toolSelected.emit(toolId);
  }
}
